import ApiConstants from '../constants/ApiConstants';
import http from '../http';

class CustomSectionService {
    static getDropdownFields() {
        return http.get(ApiConstants.URL.CUSTOM_SECTION.DROPDOWN.GET_FIELDS);
    }

    static updateDropdownOptions(payload) {
        return http.post(ApiConstants.URL.CUSTOM_SECTION.DROPDOWN.UPDATE_OPTIONS, payload);
    }
}

export default CustomSectionService;
